export default __webpack_public_path__ + "static/media/announcement_icon.f12d61b0.svg";